import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const ConceptoImpuestosRetencionesIeps = ({ data, onChange }) => {

  const handleImpuestosTipoChange = (event) => {
    const { value } = event.target;

    onChange({
      ...data,
      TipoFactor: value
    });
  }

  const handleTasaCuotaChange = (event) => {
    const { name, value } = event.target;

    onChange({
      ...data,
      [name]: value
    });
  }

  return (
    <div className="mt-2">
      <Row>
        <Col>
          IEPS
        </Col>
      </Row>

      <Row className="mt-1 form-inline control-wrapper">
        <Col xs="auto">
          <Form.Check
            type='radio'
            id="traslados_ieps_tasa"
            name="traslados_ieps_tipo"
            label="Tasa"
            value="Tasa"
            custom={ true }
            checked={ data.TipoFactor === 'Tasa' }
            onChange={ handleImpuestosTipoChange }
          />

          { data.TipoFactor === 'Tasa' && (
            <Form.Control type="number"
              name="TasaOCuota"
              label=" "
              min="0"
              max="16"
              className="text-right"
              placeholder={ data.TipoFactor }
              value={ data.TasaOCuota || '' }
              onChange={ handleTasaCuotaChange }
            />
          )}
        </Col>
      </Row>
      <Row className="mt-1 form-inline control-wrapper">
        <Col xs="auto">
          <Form.Check
            type='radio'
            id="traslados_ieps_cuota"
            name="traslados_ieps_tipo"
            label="Cuota"
            value="Cuota"
            custom={ true }
            checked={ data.TipoFactor === 'Cuota' }
            onChange={ handleImpuestosTipoChange }
          />

          { data.TipoFactor === 'Cuota' && (
            <Form.Control type="number"
              name="TasaOCuota"
              label=" "
              min="0"
              max="16"
              className="text-right"
              placeholder={ data.TipoFactor }
              value={ data.TasaOCuota || '' }
              onChange={ handleTasaCuotaChange }
            />
          )}
        </Col>
      </Row>
      <Row className="mt-1 form-inline control-wrapper">
        <Col xs="auto">
          <Form.Check
            type='radio'
            id="traslados_ieps_exento"
            name="traslados_ieps_tipo"
            label="Exento"
            value="Exento"
            custom={ true }
            checked={ data.TipoFactor === 'Exento' }
            onChange={ handleImpuestosTipoChange }
          />
        </Col>
      </Row>

    </div>
  );
}

export default ConceptoImpuestosRetencionesIeps;
